









import { Component, Provide, Vue } from "vue-property-decorator";
import AppLayout from "@/layouts/AppLayout.vue";
import { initFullLoading } from "@/event-bus";
import { AuthService } from "./services/AuthService";

@Component({
  components: {
    AppLayout
  }
})
export default class App extends Vue {
  name = "app";
  @Provide() auth: AuthService = new AuthService();
  created() {
    initFullLoading({ progress: true });
    this.auth.registerInterceptor();
  }
}
